
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getCompanyModule, saveCompanyModule } from '@/api/system';
import { getUserInfo } from '@/api/users';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'SystemSettingModule',
  components: {

  }
})
export default class extends Vue {
  private fromModule:any={}

  // 有个问题，投诉管理 一直显示，取消不了模块，测试老版也是这样。说是不能取消,
  private selectedAll: any = []
  private selectedFirst: any = []
  private selectedSecond: any = []
  private radioSecondGroup: any = ''
  private isIndeterminate: any = null;

  created() {
    this.getCompanyModule();
  }

  private getCompanyModule() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanyModule(params).then(res => {
      if (res.data) {
        this.fromModule = res.data;
        let arrOne = this.fromModule.module.filter((f: any) => {
          return f.checked === true;
        });
        this.selectedFirst = this.selectedFirst.concat(arrOne)

        for (let i = 0; i < this.fromModule.module.length; i++) {
          let arrTwo = this.fromModule.module[i].child.filter((f: any) => {
            return f.checked === true;
          });
          this.selectedSecond = this.selectedSecond.concat(arrTwo)
        }
        let arrTwoGroup = this.selectedSecond.filter((t: any) => {
          return t.checked === true && (t.module_code === 'ls385000' || t.module_code === 'ls382000' || t.module_code === 'ls381000' || t.module_code === 'ls383000' || t.module_code === 'ls386000' || t.module_code === 'ls384000');
        });
        this.radioSecondGroup = arrTwoGroup[0];

        let checkedCount = this.selectedFirst.length;
        let _length = this.fromModule.module.length;
        this.selectedAll = checkedCount === _length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private selectedFirstChange(val: any) {
    let isChecked = this.selectedFirst.filter((t: any) => {
      return t.id === val.id
    })
    if (isChecked && isChecked.length > 0) {
      val.checked = true
      this.selectedFirst = this.selectedFirst.concat(val)

      let list: any = {};
      this.selectedFirst = this.selectedFirst.reduce((item: any, next: any) => {
        // eslint-disable-next-line no-unused-expressions
        list[next.id] ? '' : list[next.id] = true && item.push(next);
        return item;
      }, []);
      if (val.module_code === 'ls130000') {
        if (val.child && val.child.length > 0) {
          this.selectedSecond.push(val.child[0])
          for (let i = 0; i < this.fromModule.module.length; i++) {
            if (this.fromModule.module[i].module_code === 'ls130000') {
              if (this.fromModule.module[i].child) {
                this.fromModule.module[i].child[0].checked = true
              }
            }
          }
        }
      }
    } else {
      val.checked = false
      this.selectedFirst = this.selectedFirst.filter((fl: any) => {
        return fl.id !== val.id;
      })
      // 下级也要全部取消
      if (val.child && val.child.length > 0) {
        for (let i = 0; i < val.child.length; i++) {
          val.child[i].checked = false
          this.selectedSecond = this.selectedSecond.filter((fl: any) => {
            return fl.id !== val.child[i].id;
          })
          if (val.module_code === 'ls380000') {
            this.radioSecondGroup = ''
          }
        }
      }
    }
    let checkedCount = this.selectedFirst.length;
    let _length = this.fromModule.module.length;
    this.selectedAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }
  private selectedSecondChange(val: any) {
    let isChecked = this.selectedSecond.filter((t: any) => {
      return t.id === val.id
    })

    if (isChecked && isChecked.length > 0) {
      val.checked = true
      // 选中的话，还需要把一级勾选上
      for (let i = 0; i < this.fromModule.module.length; i++) {
        if (this.fromModule.module[i].child) {
          for (let p = 0; p < this.fromModule.module[i].child.length; p++) {
            if (this.fromModule.module[i].child[p].id === val.id) {
              this.fromModule.module[i].checked = true
              this.selectedFirst = this.selectedFirst.concat(this.fromModule.module[i])
            }
          }
        }
      }
      let list: any = {};
      this.selectedFirst = this.selectedFirst.reduce((item: any, next: any) => {
        // eslint-disable-next-line no-unused-expressions
        list[next.id] ? '' : list[next.id] = true && item.push(next);
        return item;
      }, []);

      if (val.module_code === "ls134000" ) {
        this.selectedSecond.forEach((element:any, index:number) => {
          if (element.module_code === 'ls135000' || element.module_code === 'ls136000' ) {
            this.selectedSecond.splice(index, 1);
            for (let m = 0; m < this.fromModule.module.length; m++) {
              if (this.fromModule.module[m].child && this.fromModule.module[m].child.length > 0) {
                for (let i = 0; i < this.fromModule.module[m].child.length; i++) {
                  if (this.fromModule.module[m].child[i].module_code === 'ls135000' || this.fromModule.module[m].child[i].module_code === 'ls136000') {
                    this.fromModule.module[m].child[i].checked = false;
                  }
                }
              }
            }
          }
        });
      }
      if (val.module_code === "ls135000") {
        this.selectedSecond.forEach((element:any, index:number) => {
          if (element.module_code === 'ls134000' || element.module_code === 'ls136000' ) {
            this.selectedSecond.splice(index, 1);
            for (let m = 0; m < this.fromModule.module.length; m++) {
              if (this.fromModule.module[m].child && this.fromModule.module[m].child.length > 0) {
                for (let i = 0; i < this.fromModule.module[m].child.length; i++) {
                  if (this.fromModule.module[m].child[i].module_code === 'ls134000' || this.fromModule.module[m].child[i].module_code === 'ls136000' ) {
                    this.fromModule.module[m].child[i].checked = false;
                  }
                }
              }
            }
          }
        });
      }
      if (val.module_code === "ls136000") {
        this.selectedSecond.forEach((element:any, index:number) => {
          if (element.module_code === 'ls134000' || element.module_code === 'ls135000' ) {
            this.selectedSecond.splice(index, 1);
            for (let m = 0; m < this.fromModule.module.length; m++) {
              if (this.fromModule.module[m].child && this.fromModule.module[m].child.length > 0) {
                for (let i = 0; i < this.fromModule.module[m].child.length; i++) {
                  if (this.fromModule.module[m].child[i].module_code === 'ls134000' || this.fromModule.module[m].child[i].module_code === 'ls135000' ) {
                    this.fromModule.module[m].child[i].checked = false;
                  }
                }
              }
            }
          }
        });
      }
    } else {
      val.checked = false;
      this.selectedSecond = this.selectedSecond.filter((fl: any) => {
        return fl.id !== val.id;
      })
    }
  }
  private selectedSecondGroup(val: any) {
    // if (val.module_code === 'ls385000' || val.module_code === 'ls381000' || val.module_code === 'ls383000' || val.module_code === 'ls386000' || val.module_code === 'ls384000') {
    //   console.log(0)
    // }
    for (let i = 0; i < val.length; i++) {
      val[i].checked = false
    }
    this.radioSecondGroup.checked = true;
  }
  private CheckAllChange(val: any) {
    if (val) { // 全选
      this.selectedFirst = []
      for (let m = 0; m < this.fromModule.module.length; m++) {
        this.fromModule.module[m].checked = true;
      }
      this.selectedFirst = this.fromModule.module.filter((fl: any) => {
        return fl.checked === true;
      })
    } else { // 取消全选
      for (let m = 0; m < this.fromModule.module.length; m++) {
        this.fromModule.module[m].checked = false;
        if (parseInt(this.fromModule.module[m].no_cancel)) {
          this.fromModule.module[m].checked = true;
        }
        if (this.fromModule.module[m].child && this.fromModule.module[m].child.length > 0) {
          for (let i = 0; i < this.fromModule.module[m].child.length; i++) {
            this.fromModule.module[m].child[i].checked = false;
            if (parseInt(this.fromModule.module[m].child[i].no_cancel)) {
              this.fromModule.module[m].child[i].checked = true;
            }
          }
        }
      }
      this.selectedFirst = this.fromModule.module.filter((fl: any) => {
        return fl.checked === true;
      })
      this.selectedSecond = this.selectedFirst.filter((fl: any) => {
        return fl.checked === true;
      })
      this.radioSecondGroup = ''
    }
  }
  private saveModule() {
    this.saveData();
  }

  // private submit() {
  //   this.loading = true;
  //   this.saveData();
  // }
  private loading = false

  private saveData() {
    let modelSelectList:any = [];
    if (this.fromModule.module) {
      for (var item of this.fromModule.module) {
        if ((item as any).checked) {
          modelSelectList.push({ code: item.module_code });
          if (item.child && item.child.length > 0) {
            for (var itemChild of item.child) {
              if ((itemChild as any).checked) {
                modelSelectList.push({ code: itemChild.module_code });
              }
            }
          }
        }
      }
    }

    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.module = modelSelectList;
    saveCompanyModule(params).then(async(res) => {
      this.$notify.success({
        title: '提示',
        message: (res as any).msg
      });
      setTimeout(async() => {
        let parameters: any = {};
        parameters.user_id = UserModule.getUserId;
        parameters.company_id = UserModule.getCompanyId;
        await getUserInfo(parameters).then(async(res) => {
          await UserModule.setLogin(res.data);
        });
        this.loading = false;
        window.location.reload();
      }, 100);
    }).catch(err => {
      this.loading = false;
      this.$notify.error({
        title: '错误',
        message: err.msg
      });
    });
  }

  // handleOneLevel(checked: any, key: any) {
  //   if (checked && this.fromModule.module[key].module_code === 'ls130000') {
  //     let childChecked = false;
  //     for (var m = 0; m < this.fromModule.module[key].child.length; m++) {
  //       childChecked = this.fromModule.module[key].child[m].checked;
  //     }
  //     if (!childChecked) {
  //       this.fromModule.module[key].child[0].checked = true;
  //     }
  //   }
  //   if (!checked) {
  //     for (var i = 0; i < this.fromModule.module[key].child.length; i++) {
  //       this.fromModule.module[key].child[i].checked = false;
  //     }
  //   }
  // }

  // handleTwoLevel(checked:any, key: any, code: any) {
  //   if (checked) {
  //     if (this.fromModule.module[key].module_code === 'ls380000') {
  //       for (var i = 0; i < this.fromModule.module[key].child.length; i++) {
  //         if (this.fromModule.module[key].child[i].module_code !== code) {
  //           this.fromModule.module[key].child[i].checked = false;
  //         }
  //       }
  //     }
  //     if (this.fromModule.module[key].module_code === 'ls130000') {
  //       for (var m = 0; m < this.fromModule.module[key].child.length; m++) {
  //         if (this.fromModule.module[key].child[m].module_code !== code) {
  //           this.fromModule.module[key].child[m].checked = false;
  //         }
  //       }
  //     }
  //   } else {
  //     if (this.fromModule.module[key].module_code === 'ls130000') {
  //       for (var n = 0; n < this.fromModule.module[key].child.length; n++) {
  //         if (this.fromModule.module[key].child[n].module_code !== code) {
  //           this.fromModule.module[key].child[n].checked = true;
  //         }
  //       }
  //     }
  //   }
  // }
}
